import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from '../messages';
import type { TeamworkDocument } from '../types';
import { formatMarkdownLinkAsText } from '../utils';

const pluginInvocationStyles = cssMap({
	teamworkCard: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.small'),
		marginBottom: token('space.100'),
	},
	teamworkItemNumber: {
		minWidth: '24px',
		flexShrink: 0,
		whiteSpace: 'nowrap',
	},
});

export const TeamworkDocumentCard = ({
	doc,
	index,
}: {
	doc: TeamworkDocument;
	index: number;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={pluginInvocationStyles.teamworkCard}>
			<Stack space="space.100">
				<Inline space="space.100" alignBlock="start">
					<Box xcss={pluginInvocationStyles.teamworkItemNumber}>
						<Text weight="medium">{index + 1}.</Text>
					</Box>
					<Stack space="space.050">
						{doc.url ? (
							<Link href={doc.url} target="_blank">
								{doc.title || doc.url}
							</Link>
						) : (
							<Text weight="medium">{doc.title}</Text>
						)}
						{doc.type && (
							<Text size="small" color="color.text.subtlest">
								{doc.type}
							</Text>
						)}
					</Stack>
				</Inline>

				<Inline space="space.200" alignBlock="center">
					{doc.author && (
						<Text size="small">
							{formatMessage(messages.ai_debugger_modal_author_label, {
								author: formatMarkdownLinkAsText(doc.author),
							})}
						</Text>
					)}
					{doc.updated && (
						<Text size="small">
							{formatMessage(messages.ai_debugger_modal_teamwork_document_updated, {
								date: new Date(doc.updated).toLocaleDateString(),
							})}
						</Text>
					)}
				</Inline>

				{doc.ari && (
					<Text size="small" color="color.text.subtlest">
						{doc.ari}
					</Text>
				)}
			</Stack>
		</Box>
	);
};
